import {call,put,takeLatest,select,type CallEffect,type PutEffect,type SelectEffect,} from "redux-saga/effects";
import api from "../../services/api";
import {
  saveInventoryIntegrationLogs,
  failInventoryIntegrationLogs,
  getInventoryIntegrationLogs,
  setSupplierAggregator,
  openReportsModule
} from "../slices/reports";
import { ENDPOINT } from "../../services/apiUrls";

function buildPayload(filters: any = {}) {
  const filterPayload: any = {
    searchableKey: filters?.orderNumber || undefined,
    fromDate: filters?.fromDate,
    toDate: filters?.toDate,
    branchIds: filters?.branchIds || [],
  };

  const isSearching = !!filters?.orderNumber;
  const hasStatusFilter = !!filters?.status;

  if (hasStatusFilter) {
    if (filters.status === "Success") {
      filterPayload.isSuccess = true;
      filterPayload.requestSuccess = true;
    } 
    else if (filters.status === "Failed") {
      filterPayload.isSuccess = false;
      filterPayload.requestSuccess = true;
    } 
    else if (filters.status === "No Response") {
      filterPayload.requestSuccess = false;
    }
  } 
  else {
  }

  return {
    filter: filterPayload,
    pageSize: filters?.pageSize || 25,
    lastKey: filters?.lastKey || undefined,
  };
}


function* fetchSupplierAggregator(): Generator<
  CallEffect<any> | PutEffect<any>,
  void,
  any
> {
  try {
    const res = yield call(api.request, {
      method: "GET",
      url: ENDPOINT.REPORTS.getSupplierAggregator(),
    });

    const aggregator = res?.data?.[0]?.mid || res?.[0]?.mid || null;

    if (aggregator) {
      console.log(" Supplier Aggregator set to:", aggregator);
      yield put(setSupplierAggregator(aggregator));
    } else {
      console.warn(" No supplier aggregator found in response");
      yield put(setSupplierAggregator(null));
    }
  } catch (err) {
    console.error(" Failed to fetch supplier aggregator:", err);
    yield put(setSupplierAggregator(null));
  }
}

function* handleGetInventoryIntegrationLogs(
  action: ReturnType<typeof getInventoryIntegrationLogs>
): Generator<CallEffect<any> | PutEffect<any> | SelectEffect, void, any> {
  try {
    const filters = action.payload || {};
    const payload = buildPayload(filters);

    const aggregator: string | null = yield select(
      (state) => state.reportsReducer.supplierAggregator
    );

    if (!aggregator) {
      console.warn("No supplier aggregator configured");
      yield put(
        failInventoryIntegrationLogs("No supplier aggregator configured")
      );
      return;
    }

    const response: any = yield call(api.request, {
      method: "POST",
      url: ENDPOINT.REPORTS.getSupplierAggregatorLogs(aggregator),
      data: payload,
    });

    const data = response?.data || response;
    const logs = data?.requestLogs ?? data?.logs ?? [];
    const lastKey = data?.lastKey ?? null;

    const ninetyDaysAgo = new Date();
    ninetyDaysAgo.setDate(ninetyDaysAgo.getDate() - 90);
    const filteredLogs = logs.filter((log: any) => {
      const ts =
        log?.createdDate ||
        log?.timestamp ||
        log?.request?.created ||
        log?.request?.updated;
      return ts && new Date(ts) >= ninetyDaysAgo;
    });

    yield put(
      saveInventoryIntegrationLogs({
        logs: filteredLogs,
        lastKey,
        append: filters?.append || false,
      })
    );
  } catch (err: any) {
    console.error("Error fetching inventory integration logs:", err);
    const message =
      err?.response?.data || err?.message || "Failed to fetch inventory logs";
    yield put(failInventoryIntegrationLogs(message));
  }
}

export function* watchReportsModule(): Generator {
  yield takeLatest(openReportsModule.type, fetchSupplierAggregator);
}

export function* watchInventoryIntegrationLogs(): Generator {
  yield takeLatest(
    getInventoryIntegrationLogs.type,
    handleGetInventoryIntegrationLogs
  );
}
